import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Add from './add'
import Grid from './grid'
import { AccordionWithArrow } from '../../../../components'
// import { DataGridWithAccordion, DataGridWithSorting } from '../../../../components/dataGrid'
import { Wrapper } from './style'

const Question1 = ({ settings, onChange }) => {
  const [updatedData, setUpdatedData] = useState(0)
  const updatedDataFunc = (obj = {}) => {
    setUpdatedData(updatedData + 1)
  }

  return (
    <Wrapper>
      <AccordionWithArrow title={settings.title} expanded={settings.expand} accordionstyle='fieldset' showArrow={false} onExpandChange={(expandVal) => onChange({ ...settings, expand: expandVal })}>
        {/* <DataGridWithAccordion /> */}
        {/* <DataGridWithSorting /> */}
        {settings?.type && <Add onChange={updatedDataFunc} settings={settings} />}
        {settings?.type && <Grid refreshData={updatedData} settings={settings} />}
      </AccordionWithArrow>
    </Wrapper>
  )
}

Question1.propTypes = {
  settings: PropTypes.object,
  onChange: PropTypes.func
}

export default Question1
